import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { isBefore } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
var ManageScoresComponent = /** @class */ (function () {
    function ManageScoresComponent(appService, dialogService, errorService, mediaChange, splashService, userService) {
        this.appService = appService;
        this.dialogService = dialogService;
        this.errorService = errorService;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['TestDescription', 'Description', 'ScoreType', 'Score', 'Active', 'Actions'];
        this.FilterText = '';
        this.FilteredTests = [];
        this.OnlyActive = true;
    }
    ManageScoresComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        self.NoData = false;
        self.PartialViewReady = false;
        self.TestsList = null;
        self.TestsData = new DataTableSource([], self.paginator, self.sorter, self.SortTests.bind(self));
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            var threasholdsObs = self.appService.GetTestThresholds(self.User.AuthToken);
            combineLatest(threasholdsObs, function (threshes) {
                return {
                    Thresholds: threshes,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                _this.TestsList = packet.Thresholds;
                if (!_this.TestsList || !_this.TestsList.length) {
                    self.NoData = true;
                    // Put in a fake record to trip the display message
                    self.TestsData.dataChange.next([{}]);
                }
                else {
                    self.NoData = false;
                    self.UpdateFilter();
                    // self.TestsData.dataChange.next(self.TestsList);
                }
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
                // Ready for component use.
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    ManageScoresComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Activate Test
    ManageScoresComponent.prototype.ActivateTest = function (test) {
        var self = this;
        test.Active = true;
        // User has opted to proceed. Signal the system to remove this term window from the college.
        self.appService.UpdateTestThreshold(self.User.AuthToken, self.User.CurrentRole, test, this.User).subscribe(function (test) {
            // Toast the success
            self.splashService.SnackbarSuccess('Test score threshold activated successfully.');
            // Find the previous entry in the loaded list, update it by removing the score and clearing the active flag, then
            // reset the data source.
            var entry = self.TestsList.find(function (t) { return t.TestThresholdID === test.TestThresholdID; });
            if (entry != null) {
                entry.Active = true;
            }
            self.TestsData.Update(self.TestsList);
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    // #endregion
    // #region Deactivate Test
    ManageScoresComponent.prototype.DeactivateTest = function (test) {
        var self = this;
        test.Active = false;
        // User has opted to proceed. Signal the system to remove this term window from the college.
        self.appService.UpdateTestThreshold(self.User.AuthToken, self.User.CurrentRole, test, this.User).subscribe(function (test) {
            // Toast the success
            self.splashService.SnackbarSuccess('Test score threshold activated successfully.');
            // Find the previous entry in the loaded list, update it by removing the score and clearing the active flag, then
            // reset the data source.
            var entry = self.TestsList.find(function (t) { return t.TestThresholdID === test.TestThresholdID; });
            if (entry != null) {
                entry.Active = false;
            }
            self.TestsData.Update(self.TestsList);
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    // #endregion
    // #region Edit Test
    ManageScoresComponent.prototype.EditTest = function (test) {
        var _this = this;
        var self = this;
        self.dialogService
            .OpenEditTestThresholdDialog({
            TitleText: 'Edit Test Score',
            MessageText: "You have chosen to edit the following test score cutoff:<br /><br />\n                                <strong>Test: </strong>" + test.TestDescription + "<br />\n                                <strong>Subject: </strong>" + test.Description + "<br />" +
                (test.Score ? "<strong>Score: </strong>" + test.Score + "<br />" : ''),
            OKText: 'Yes - SAVE CHANGES',
            CancelText: 'No - CANCEL',
            TestThresholdInfo: test,
        })
            .subscribe(function (result) {
            if (result) {
                test.Score = result;
                // User has opted to proceed. Signal the system to remove this term window from the college.
                self.appService.UpdateTestThreshold(self.User.AuthToken, self.User.CurrentRole, test, _this.User).subscribe(function (test) {
                    // Toast the success
                    self.splashService.SnackbarSuccess('Test score threshold updated successfully.');
                    // Find the previous entry in the loaded list, update it by removing the score and clearing the active flag, then
                    // reset the data source.
                    var entry = self.TestsList.find(function (t) { return t.TestThresholdID === test.TestThresholdID; });
                    if (entry != null) {
                        entry.TestThresholdID = test.TestThresholdID;
                        entry.TestDescription = test.TestDescription;
                        entry.ContentCode = test.ContentCode;
                        entry.Description = test.Description;
                        entry.TestName = test.TestName;
                        entry.ScoreType = test.ScoreType;
                        entry.Score = test.Score;
                        entry.Active = test.Active;
                        entry.DateUpdated = test.DateUpdated;
                        entry.UpdatedBy = test.UpdatedBy;
                        entry.UpdatedByLastName = test.UpdatedByLastName;
                        entry.UpdatedByFirstName = test.UpdatedByFirstName;
                        entry.UpdatedByLocalJobTitle = test.UpdatedByLocalJobTitle;
                    }
                    self.TestsData.Update(self.TestsList);
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Remove Test
    ManageScoresComponent.prototype.RemoveTest = function (test) {
        var self = this;
        if (!test) {
            return;
        }
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You have chosen to remove the following test score cutoff:<br /><br />\n            <strong>Test: </strong>" + test.TestDescription + "<br />\n            <strong>Subject: </strong>" + test.Description + "<br />\n            <strong>Score: </strong>" + test.Score + "<br />\n            <br /><br />Once removed, this test score cutoff must be added again in order for it to appear in the DELTA system. Are you sure you wish to continue?",
            OKText: 'Yes - Remove Test Cutoff',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to remove this term window from the college.
                self.appService.RemoveTestThreshold(self.User.AuthToken, self.User.CurrentRole, test.TestThresholdID).subscribe(function (testID) {
                    // Toast the success
                    self.splashService.SnackbarSuccess('Test score threshold removed successfully.');
                    // Find the previous entry in the loaded list, update it by removing the score and clearing the active flag, then
                    // reset the data source.
                    var entry = self.TestsList.find(function (t) { return t.TestThresholdID === testID; });
                    if (entry != null) {
                        entry.Active = false;
                        entry.Score = null;
                    }
                    self.TestsData.Update(self.TestsList);
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Sort Tests Method
    ManageScoresComponent.prototype.SortTests = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'TestDescription':
                _a = [First.TestDescription, Second.TestDescription], PropA = _a[0], PropB = _a[1];
                break;
            case 'Description':
                _b = [First.Description, Second.Description], PropA = _b[0], PropB = _b[1];
                break;
            case 'Active':
                _c = [First.Active === true ? 'Yes' : 'No', Second.Active === true ? 'Yes' : 'No'], PropA = _c[0], PropB = _c[1];
                break;
        }
        if (PropA instanceof Date) {
            return (isBefore(PropA, PropB) ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c;
    };
    // #endregion
    // #region Update Filter
    ManageScoresComponent.prototype.UpdateFilter = function () {
        var self = this;
        var ltext = self.FilterText.toLocaleLowerCase();
        self.FilteredTests = (self.TestsList || []).filter(function (t) {
            return ((!self.OnlyActive || t.Active === true) &&
                (!ltext ||
                    t.TestDescription.toLocaleLowerCase().indexOf(ltext) >= 0 ||
                    t.Description.toLocaleLowerCase().indexOf(ltext) >= 0));
        });
        self.TestsData.dataChange.next(self.FilteredTests);
    };
    return ManageScoresComponent;
}());
export { ManageScoresComponent };



// WEBPACK FOOTER //
// ./src/app/managescores/managescores.component.ts.pre-build-optimizer.js